/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Act_StartInputs */

const vi_cdo_act_start = /** @type {(inputs: Cdo_Act_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu giao`)
};

/**

* @param {Cdo_Act_StartInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_act_start = /** @type {((inputs?: Cdo_Act_StartInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Act_StartInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_act_start(inputs)
});